// Polyfill in case Localstorage does not exist.
const Storage = function() {
	this.data = {};
};

Storage.getInstance = function() {
	if ( ! Storage.instance ) {
		Storage.instance = new Storage();
	}
	return Storage.instance;
};

Storage.prototype.setItem = function( key, val ) {
	this.data[ key ] = val;
};

Storage.prototype.getItem = function( key ) {
	return this.data[ key ];
};

Storage.getLocalStorage = function() {
	try {
		if ( window.localStorage ) {
			return window.localStorage;
		}
		return Storage.getInstance();
	} catch ( ex ) {
		return Storage.getInstance();
	}
};

Storage.getSessionStorage = function() {
	try {
		if ( window.sessionStorage ) {
			return window.sessionStorage;
		}
		return Storage.getInstance();
	} catch ( ex ) {
		return Storage.getInstance();
	}
};

export default Storage;
